








































































































































import Component, { mixins } from "vue-class-component";
import BaseTable, { StringKeyObject } from "@/components/common/BaseTable.vue";
import { HeaderWidthItem } from "@/types";
import AxiosMixin from "../mixins/axiosMixin";
import { Ref } from "vue-property-decorator";
import LoadingDialog from "@/components/common/LoadingDialog.vue";
import RadioGroupDialog from "@/components/common/RadioGroupDialog.vue";
import SelectFilter, { ColumnKey } from "@/components/common/SelectFilter.vue";

@Component({
  components: {
    BaseTable,
    LoadingDialog,
    RadioGroupDialog,
    SelectFilter
  }
})
export default class AccountTransferManage extends mixins(AxiosMixin) {
  @Ref("baseTable") private readonly baseTable!: BaseTable;
  @Ref("newcodeChangeDialog")
  private readonly newcodeChangeDialog!: RadioGroupDialog;
  @Ref("selectFilter")
  private readonly selectFilter!: SelectFilter;

  private headerItems: HeaderWidthItem[] = [
    {
      value: "ibow_id",
      text: "利用者ID",
      width: "98px",
      filter: (val: object) => this.columnFilter("ibow_id", val)
    },
    {
      value: "sortable_customer_no",
      text: "顧客番号",
      width: "130px",
      description:
        "ご利用者様個人を特定する（一意の）情報として、iBowレセプトで生成している全銀フォーマット内の顧客番号20桁です。",
      filter: (val: object) =>
        this.customerNoColumnFilter("sortable_customer_no", val)
    },
    {
      value: "newcode",
      text: "新規コード",
      width: "98px",
      description:
        "利用者請求管理＞口座振替データ出力で出力される全銀フォーマット内の新規コードです。<br />ご利用の口座振替サービスで新規コードが指定されている場合はこちらで設定できます。<br />1：初回振替分、0：2回目以降　を表します。",
      filterType: SelectFilter.FILTER_TYPE_LIST,
      filter: (val: object) => this.columnFilter("newcode", val)
    },
    {
      value: "patient_name",
      text: "氏名",
      width: "140px",
      filter: (val: object) => this.columnFilter("patient_name", val)
    },
    {
      value: "furigana",
      text: "ﾌﾘｶﾞﾅ",
      width: "140px",
      filter: (val: object) => this.columnFilter("furigana", val)
    },
    {
      value: "payment_method",
      text: "支払方法",
      width: "98px",
      filterType: SelectFilter.FILTER_TYPE_LIST,
      filter: (val: object) => this.columnFilter("payment_method", val)
    },
    {
      value: "payment_start",
      text: "引落開始設定",
      width: "130px",
      filterType: SelectFilter.FILTER_TYPE_LIST,
      filter: (val: object) => this.columnFilter("payment_start", val)
    }
  ];

  private useAnyHeaderItems: HeaderWidthItem[] = [
    {
      value: "ibow_id",
      text: "利用者ID",
      width: "98px",
      filter: (val: object) => this.columnFilter("ibow_id", val)
    },
    {
      value: "sortable_customer_no",
      text: "顧客番号",
      width: "130px",
      description:
        "ご利用者様個人を特定する（一意の）情報として、iBowレセプトで生成している全銀フォーマット内の顧客番号20桁です。",
      filter: (val: object) =>
        this.customerNoColumnFilter("sortable_customer_no", val)
    },
    {
      value: "sortable_any_customer_no",
      text: "顧客番号(任意)",
      width: "130px",
      description:
        "利用者個人を特定する（一意な）情報として、設定＞顧客番号(任意)利用設定にて【利用する】を選択している場合、事業所で<br />任意に登録できる全銀フォーマット内の顧客番号20桁です。<br />口座情報出力ボタンより出力したExcelデータ内に顧客番号(任意)を入力のうえ、口座情報取込ボタンより取込してください。<br />利用者請求管理＞口座振替データ出力時には顧客番号(任意)で登録した顧客番号を出力します。",
      filter: (val: object) =>
        this.customerNoColumnFilter("sortable_any_customer_no", val)
    },
    {
      value: "newcode",
      text: "新規コード",
      width: "98px",
      description:
        "利用者請求管理＞口座振替データ出力で出力される全銀フォーマット内の新規コードです。<br />ご利用の口座振替サービスで新規コードが指定されている場合はこちらで設定できます。<br />1：初回振替分、0：2回目以降　を表します。",
      filterType: SelectFilter.FILTER_TYPE_LIST,
      filter: (val: object) => this.columnFilter("newcode", val)
    },
    {
      value: "patient_name",
      text: "氏名",
      width: "140px",
      filter: (val: object) => this.columnFilter("patient_name", val)
    },
    {
      value: "furigana",
      text: "ﾌﾘｶﾞﾅ",
      width: "140px",
      filter: (val: object) => this.columnFilter("furigana", val)
    },
    {
      value: "payment_method",
      text: "支払方法",
      width: "98px",
      filterType: SelectFilter.FILTER_TYPE_LIST,
      filter: (val: object) => this.columnFilter("payment_method", val)
    },
    {
      value: "payment_start",
      text: "引落開始設定",
      width: "130px",
      filterType: SelectFilter.FILTER_TYPE_LIST,
      filter: (val: object) => this.columnFilter("payment_start", val)
    }
  ];

  //------------------------------------------
  // SelectFilterの選択肢
  //------------------------------------------
  private get columnKeys(): ColumnKey[] {
    return this.headerItems
      .filter(hditm => {
        return hditm.filter != null;
      })
      .map(hditm => {
        let type = SelectFilter.FILTER_TYPE_EDIT;
        if (hditm.filterType != null) {
          type = hditm.filterType;
        }
        let selectable = null;
        if (
          hditm.filterType === SelectFilter.FILTER_TYPE_LIST ||
          hditm.filterType === SelectFilter.FILTER_TYPE_EDIT_LIST
        ) {
          //選択肢一覧作成
          selectable = this.tableItems
            .map((itm: any) => {
              let txt;
              if (
                hditm.value == "sortable_customer_no" ||
                hditm.value == "sortable_any_customer_no"
              ) {
                // 選択肢一覧の顧客番号からプレフィックスを取り除く
                txt = String(itm[hditm.value]).replace("SORT_", "");
              } else if (hditm.value == "newcode") {
                // 数値の場合0の時に同じカラムの検索条件の抽出がされず、0以外の時は文字変換時にエラーとなるため文字列に変換
                txt = String(itm[hditm.value]);
              } else {
                txt = itm[hditm.value];
              }
              return txt === "" ? SelectFilter.NO_DATA : txt;
            })
            .filter((val, idx, arr) => {
              return arr.indexOf(val) === idx;
            });
          //NO_DATAラベルを一覧の先頭に移動
          const idx = selectable.indexOf(SelectFilter.NO_DATA);
          if (idx > 0) {
            this.moveAt(selectable, idx, 0);
          }
        }
        const fkey: ColumnKey = {
          type: type,
          key: hditm.value,
          text: hditm.text,
          selectable: selectable
        };
        return fkey;
      });
  }

  //------------------------------------------
  // カラムフィルター
  //------------------------------------------
  private columnFilter(key: string, val: object) {
    const bret = this.selectFilter.isMatch(key, val);

    // テーブル更新
    if (this.baseTable) {
      this.baseTable.handle();
    }
    return bret;
  }

  private customerNoColumnFilter(key: string, val: object) {
    // 顧客番号のプレフィックスがあると選択肢一覧や前方一致の入力でヒットしないため、検索対象文字列から取り除く
    const strVal = String(val).replace("SORT_", "");
    // プリミティブの文字列とStringオブジェクトの厳密等価演算でfalseとなり、リスト選択でデータなしの場合に意図しない結果となる
    // valueOf()を用いることでプリミティブの文字列に変換し、データなしの場合でも正しく動作する
    return this.columnFilter(key, Object(strVal).valueOf());
  }

  //------------------------------------------
  // 配列要素の移動
  //------------------------------------------
  private moveAt(array: object[], idx: number, at: number) {
    if (idx === at || idx > array.length - 1 || at > array.length - 1) {
      return;
    }
    const value = array[idx];
    const tail = array.slice(idx + 1);
    array.splice(idx);
    Array.prototype.push.apply(array, tail);
    array.splice(at, 0, value);
  }

  private tableItems: object[] = [];

  private objectIds: StringKeyObject[] = []; //選択対象ID

  private useAnyCustomerNumberDiv = "0";

  //結果ファイル取込ダイアログ
  private isFileSelectActive = false;
  //取込結果表示ダイアログ
  private resultDialog = false;
  //取込結果
  private resultMsg = "";
  //取込ファイル
  private fileBank: Blob | null = null;

  //-------------------------------
  // mounted()
  //-------------------------------
  mounted() {
    // 画面復帰設定（チェックボックス、フィルタ条件）
    if (!this.$route.query.st) {
      this.baseTable.clearAllCheck();
      this.selectFilter.clearAll();
    } else {
      this.baseTable.restoreStorage();
      this.selectFilter.restoreStorage();
    }
    // 画面更新
    this.updateData();
  }

  //-------------------------------
  // 口座振替情報取得
  //-------------------------------
  private updateData() {
    this.fileBank = null;

    this.postJsonCheck(
      window.base_url + "/api/office/accounttransfer/list",
      {},
      res => {
        this.tableItems = res.data.lists;
        this.useAnyCustomerNumberDiv = res.data.use_any_customer_number_div;
        if (this.useAnyCustomerNumberDiv == "1") {
          this.headerItems = this.useAnyHeaderItems;
        }
        this.createSortableCustomerNo();
        this.createSortableAnyCustomerNo();
        this.$router.replace(`/account_transfer?st=1`).catch(err => err);
        this.$nextTick(() => {
          this.baseTable.restoreStorage();
          this.baseTable.updateBaseTable();
          // テーブルヘッダ変更時にヘッダの幅がおかしくなるため、resizeイベント時の処理(initField, getWidthFixHeader)で幅を再取得させる
          window.dispatchEvent(new Event("resize"));
        });
      }
    );
  }

  //-------------------------------
  // ソート用顧客番号作成
  // 20桁数値文字列でソートすると、ソートされない。
  // プレフィックスに"SORT_"をつけて文字列と認識させると正常にソートが動作する。
  // 表示側BaseTable.vueでプレフィックスをトリムして表示させる。
  // （おそらく数値変換で桁落ちして、正しくソートされない。）
  //-------------------------------
  private createSortableCustomerNo() {
    this.tableItems.forEach((item: any) => {
      item.sortable_customer_no = `SORT_${item.customer_no}`;
    });
  }
  // ソート用顧客番号(任意)作成
  private createSortableAnyCustomerNo() {
    this.tableItems.forEach((item: any) => {
      item.sortable_any_customer_no = `SORT_${item.any_customer_number}`;
    });
  }

  //-------------------------------
  // 検索
  //-------------------------------
  private search() {
    this.baseTable.clearAllCheck();
    this.updateData();
  }

  //-------------------------------
  // エクセルダウンロード
  //-------------------------------
  private downloadExcel() {
    if (this.baseTable.confirmAllSelect() === false) {
      return;
    }

    const fname = `口座振替データ管理_${this.dateFormat(new Date())}.xlsx`;
    const params = {
      items: this.baseTable.SelectedItems(),
      use_any_customer_number_div: this.useAnyCustomerNumberDiv
    };
    this.postJsonBlobRes(
      window.base_url + "/api/office/accounttransfer/excel",
      params,
      res => {
        const blob = new Blob([res.data]);
        const a = document.createElement("a");
        a.download = fname;
        a.href = URL.createObjectURL(blob);
        a.click();
      }
    );
  }

  //-------------------------------
  // 更新値選択ダイアログ表示
  //-------------------------------
  private openNewcodeDialog() {
    if (this.baseTable.confirmAllSelect() === false) {
      return;
    }
    this.newcodeChangeDialog.open(null);
  }

  //-------------------------------
  // 更新値選択ダイアログで設定したインデックス取得 & 更新処理実施
  //-------------------------------
  private onNewcodeChanged(idx: number) {
    const items = this.baseTable.SelectedItems();
    const val = idx == 0 ? 1 : 0;
    const params = {
      items: items,
      value: val
    };
    this.postJsonCheck(
      window.base_url + "/api/office/accounttransfer/update-newcode",
      params,
      res => {
        this.updateData();
      }
    );
  }

  //-------------------------------
  // 日付フォーマット(yyyyMMdd_HHmmss)
  //-------------------------------
  private dateFormat(d: Date) {
    const ymd = `${d.getFullYear()}${(d.getMonth() + 1)
      .toString()
      .padStart(2, "0")}${d
      .getDate()
      .toString()
      .padStart(2, "0")}`;
    const hms = `${d
      .getHours()
      .toString()
      .padStart(2, "0")}${d
      .getMinutes()
      .toString()
      .padStart(2, "0")}${d
      .getSeconds()
      .toString()
      .padStart(2, "0")}`;
    return `${ymd}_${hms}`;
  }

  //---------------------------------------------
  //口座情報取込
  //---------------------------------------------
  //口座情報取込ダイアログ表示
  private openImportDialog() {
    this.isFileSelectActive = true;
  }
  private closeImportDialog() {
    this.isFileSelectActive = false;
    this.fileBank = null;
  }
  //口座情報取込ダイアログ閉じる
  private closeResultDialog() {
    this.resultDialog = false;
    this.updateData();
  }
  //取込処理
  private importResult() {
    if (!this.fileBank) {
      alert("ファイルが選択されていません。");
      return;
    }
    if (!confirm("口座振替情報を取り込みます。よろしいですか？")) {
      return;
    }
    const formData = new FormData();
    formData.append("uploadfile", this.fileBank);
    this.postForm(
      window.base_url + "/api/office/accounttransfer/impaccount",
      formData,
      response => {
        if (response.data.code != 0) {
          alert(response.data.message);
          return;
        }
        this.isFileSelectActive = false;
        this.resultMsg = response.data.result_text;
        this.resultDialog = true;
      }
    );
  }

  //---------------------------------------------
  //取込結果ダウンロード
  //---------------------------------------------
  private downloadResult() {
    const blob = new Blob([this.resultMsg]);
    const a = document.createElement("a");
    // a.download = `取込結果${this.yearmonth}.txt`;
    a.download = `取込結果_${this.dateFormat(new Date())}.txt`;
    a.href = URL.createObjectURL(blob);
    a.click();
  }
}
